import React, { memo } from 'react';

import { Box } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PopTipCDS from '@sharedCR/coreDesignSystem/PopTipCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { iconStyles, wrapperStyles } from './LabelWithTooltip.styles';

const popperProps = { disablePortal: false };

const LabelWithTooltip = ({ label, description }) => (
  <Box component="span" sx={wrapperStyles}>
    {label}
    {/* Portal the popup out of the field <Label>, whose `truncate`
        (overflow: hidden) clips the app-wide disablePortal tooltip. */}
    <PopTipCDS PopperProps={popperProps} placement="top" title={description}>
      <Box component="span" sx={iconStyles}>
        <InfoIcon size={IconSize[16]} />
      </Box>
    </PopTipCDS>
  </Box>
);

LabelWithTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default memo(LabelWithTooltip);
